<template lang="pug">
  div
    .christmasTree(ref="christmasTree")
      img(src="@/assets/img/christmasTree.png")
      transition(name="fade")
        .help_message(v-if="showTreeHelp")
          span Кликни, чтобы найти<br> поздравление

      .ball.ball_1.blue

      .ball.ball_2.red

      .ball.ball_3_1.blue
      .ball.ball_3_2.blue

      .ball.ball_4_1.red
      .ball.ball_4_2.red
      .ball.ball_4_3.red

      .ball.ball_5_1.blue
      .ball.ball_5_2.blue
      .ball.ball_5_3.blue

      .ball.ball_6_1.red
      .ball.ball_6_2.red
      .ball.ball_6_3.red
      .ball.ball_6_4.red
      .ball.ball_6_5.red

      .ball.ball_7_1.blue
      .ball.ball_7_2.red
      .ball.ball_7_3.blue

      .ball.ball_8_1.red
      .ball.ball_8_2.blue
      .ball.ball_8_3.blue
      .ball.ball_8_4.red
      .ball.ball_8_5.blue
      .ball.ball_8_6.red
      .ball.ball_8_7.blue

      .ball.ball_9_1.blue
      .ball.ball_9_2.red
      .ball.ball_9_3.blue
      .ball.ball_9_4.red
      .ball.ball_9_5.blue
      .ball.ball_9_6.blue
      .ball.ball_9_7.red

      .ball.ball_10_1.blue
      .ball.ball_10_2.red
      .ball.ball_10_3.blue
      .ball.ball_10_4.red

      .ball.ball_11_1.blue
      .ball.ball_11_2.red
      .ball.ball_11_3.blue
      .ball.ball_11_4.red

      tree-light(v-if="showTreeLight" @hide="$emit('hideTreeLight')")
      .gift_glow(@click="showVideo=gift" :class="{disabled: !gift}")
      .starVideo(@click="showVideo=starVideo")

    video-popup(v-if="showVideo" :src="showVideo" @close="showVideo=null")
</template>

<script>
import TreeLight from "@/components/TreeLight";
import VideoPopup from "@/components/VideoPopup";

export default {
  name: "ChristmasTree",
  components: {VideoPopup, TreeLight},
  props: {
    showTreeLight: {
      default: false
    },
    showTreeHelp: {
      default: false
    },
    videos: {},
    wishes: {},
    gift: {},
  },

  data: () => ({
    showVideo: null,
    starVideo: 'https://youtu.be/hbVgvgN2Kik',
  }),

  mounted() {
    const balls = this.$refs.christmasTree.querySelectorAll('.ball');
    balls.forEach((ball, index) => {
      if (this.videos?.[index]) {
        ball.classList.add('active')
        ball.addEventListener('click', () => {
          this.showVideo = this.videos[index];
        })
      }
    });
    const lights = document.createDocumentFragment();
    let lightsCount = this.wishes.length;
    if (lightsCount > 129) {
      lightsCount = 129;
    }
    for (let i = 1; i <= lightsCount; i++) {
      const light = document.createElement('div');
      light.classList.add('light');
      light.classList.add(`light_${i}`);
      lights.appendChild(light);
    }
    this.$refs.christmasTree.appendChild(lights);
  }
}
</script>

<style scoped lang="scss">
.christmasTree {
  position: relative;
  width: 75rem;

  img {
    width: 100%;
  }

  .help_message {
    position: absolute;
    z-index: 2;
    top: 46%;
    left: 36.2%;
    transform: translate(-50%, -50%);
    span {
      display: block;
      padding: 0.8rem 1.5rem;
      border-radius: 2rem;
      background: rgba($blue, 0.65);
      font-size: 1rem;
      line-height: 1.2;
      text-transform: uppercase;
      text-align: center;
      animation: puls 1s linear infinite alternate;
      @include mobile_or_P {
        padding: 0.35rem 1rem;
        border-radius: 1rem;
        font-size: 0.65rem;
      }
      @keyframes puls {
        from {
          transform: scale(1);
        }
        to {
          transform: scale(1.05);
        }
      }
    }
    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      background: url(../assets/img/whiteArrow.png)  no-repeat center center / contain;
      width: 10rem;
      height: 10rem;
      @include mobile_or_P {
        width: 6.4rem;
        height: 6.4rem;
      }
    }
    &:before {
      bottom: 91%;
      left: 53%;
    }
    &:after {
      top: 120%;
      left: 28%;
      transform: rotate(127deg);
    }
  }

  .gift_glow {
    position: absolute;
    bottom: 25.58%;
    left: 34.1%;
    width: 12.3%;
    height: 12.3%;
    background: url(../assets/img/gift_glow.png) no-repeat center center / contain;
    opacity: 0;
    transition: opacity .2s;
    cursor: pointer;
    &.disabled {
      pointer-events: none;
    }
    &:hover {
      opacity: 0.2;
    }
  }
  .starVideo {
    position: absolute;
    top: 9.1%;
    left: 52.8%;
    width: 8%;
    height: 8%;
    background: url(../assets/img/red_glow.png) no-repeat center center / contain;
    opacity: 0;
    transition: opacity .2s;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
  .ball {
    position: absolute;
    width: 1.85rem;
    height: 1.85rem;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    //background: rgba(green, 0.7);

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: to_rem(112px);
      height: to_rem(112px);
      background: no-repeat center center / contain;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s;
    }

    &.active {
      cursor: pointer;
      &:after {
        opacity: 0.7;
      }
      &:hover:after {
        opacity: 1;
      }
    }

    &_1 {
      top: 22.3%;
      left: 56.7%;
    }

    &_2 {
      top: 25.8%;
      left: 56.7%;
    }

    &_3 {
      &_1 {
        top: 29.35%;
        left: 53.3%;
      }

      &_2 {
        top: 29.35%;
        left: 60.6%;
      }
    }

    &_4 {
      &_1 {
        top: 32.2%;
        left: 49.6%;
      }

      &_2 {
        top: 32.1%;
        left: 56.8%;
      }

      &_3 {
        top: 32.2%;
        left: 64%;
      }
    }

    &_5 {
      &_1 {
        top: 38.7%;
        left: 52%;
      }

      &_2 {
        top: 36.1%;
        left: 56.7%;
      }

      &_3 {
        top: 38.8%;
        left: 62%;
      }
    }

    &_6 {
      &_1 {
        top: 41.8%;
        left: 47.1%;
      }

      &_2 {
        top: 42.7%;
        left: 52.2%;
      }

      &_3 {
        top: 41.3%;
        left: 56.8%;
      }

      &_4 {
        top: 42.8%;
        left: 61.7%;
      }

      &_5 {
        top: 41.9%;
        left: 66.6%;
      }
    }

    &_7 {
      &_1 {
        top: 45.4%;
        left: 49.6%;
      }

      &_2 {
        top: 45.4%;
        left: 56.8%;
      }

      &_3 {
        top: 45.5%;
        left: 63.9%;
      }
    }

    &_8 {
      &_1 {
        top: 51%;
        left: 44.3%;
      }

      &_2 {
        top: 53.1%;
        left: 49.9%;
      }

      &_3 {
        top: 49%;
        left: 56.7%;
      }

      &_4 {
        top: 52%;
        left: 56.8%;
      }

      &_5 {
        top: 53.3%;
        left: 62.8%;
      }

      &_6 {
        top: 50.8%;
        left: 68.7%;
      }

      &_7 {
        top: 54.7%;
        left: 68.7%;
      }
    }

    &_9 {
      &_1 {
        top: 55%;
        left: 44%;
      }

      &_2 {
        top: 58.1%;
        left: 43.1%;
      }

      &_3 {
        top: 59.5%;
        left: 48.3%;
      }

      &_4 {
        top: 58.1%;
        left: 56.8%;
      }

      &_5 {
        top: 61.8%;
        left: 56.8%;
      }

      &_6 {
        top: 60.7%;
        left: 64.1%;
      }

      &_7 {
        top: 58.2%;
        left: 70%
      }
    }

    &_10 {
      &_1 {
        top: 65%;
        left: 50.8%;
      }

      &_2 {
        top: 64.9%;
        left: 56.8%;
      }

      &_3 {
        top: 64.9%;
        left: 64%;
      }

      &_4 {
        top: 64.9%;
        left: 71.9%;
      }
    }

    &_11 {
      &_1 {
        top: 70.5%;
        left: 50.7%;
      }

      &_2 {
        top: 71.4%;
        left: 56.8%;
      }

      &_3 {
        top: 70.4%;
        left: 65%;
      }

      &_4 {
        top: 70.4%;
        left: 71%;
      }
    }

    &.red:after {
      background-image: url(../assets/img/red_glow.png);
    }

    &.blue:after {
      background-image: url(../assets/img/blue_glow.png);
    }
  }
  &::v-deep {
    .light {
      position: absolute;
      z-index: 1;
      width: to_rem(8px);
      height: to_rem(8px);
      transform: translate(-50%, -50%);
      //pointer-events: none;

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.5rem;
        height: 2.5rem;
        background: url(../assets/img/light_on_tree.png) no-repeat center center / contain;
        pointer-events: none;
        @include mobile_or_P {
          width: 1.5rem;
          height: 1.5rem;
        }
      }

      &_1 {
        top: 18.5%;
        left: 56.3%;
      }
      &_2 {
        top: 20.5%;
        left: 55.6%;
      }
      &_3 {
        top: 23.5%;
        left: 58.6%;
      }
      &_4 {
        top: 27.5%;
        left: 54.6%;
      }
      &_5 {
        top: 25.5%;
        left: 52.6%;
      }
      &_6 {
        top: 30.3%;
        left: 55.2%;
      }
      &_7 {
        top: 31.5%;
        left: 55.6%;
      }
      &_8 {
        top: 28.5%;
        left: 58.6%;
      }
      &_9 {
        top: 26.9%;
        left: 53%;
      }
      &_10 {
        top: 19.5%;
        left: 58%;
      }

      &_11 {
        top: 33%;
        left: 51.5%;
      }
      &_12 {
        top: 33.2%;
        left: 58%;
      }
      &_13 {
        top: 31.2%;
        left: 61%;
      }
      &_14 {
        top: 35%;
        left: 49%;
      }
      &_15 {
        top: 36%;
        left: 50%;
      }
      &_16 {
        top: 37.5%;
        left: 52%;
      }
      &_17 {
        top: 35%;
        left: 54%;
      }
      &_18 {
        top: 38.5%;
        left: 56.5%;
      }
      &_19 {
        top: 35.5%;
        left: 59.5%;
      }
      &_20 {
        top: 33.5%;
        left: 62%;
      }

      &_21 {
        top: 37.5%;
        left: 60%;;
      }
      &_22 {
        top: 36%;
        left: 62.5%;
      }
      &_23 {
        top: 40.5%;
        left: 59.5%;
      }
      &_24 {
        top: 41.5%;
        left: 55.3%;
      }
      &_25 {
        top: 39.5%;
        left: 53.6%;
      }
      &_26 {
        top: 42.5%;
        left: 60%;
      }
      &_27 {
        top: 41.5%;
        left: 62%;
      }
      &_28 {
        top: 43.2%;
        left: 58%;
      }
      &_29 {
        top: 44.5%;
        left: 62%;
      }
      &_30 {
        top: 37%;
        left: 46.5%;
      }

      &_31 {
        top: 39%;
        left: 47.5%;
      }
      &_32 {
        top: 41.5%;
        left: 45%;
      }
      &_33 {
        top: 40.5%;
        left: 49%;
      }
      &_34 {
        top: 42%;
        left: 50.5%;
      }
      &_35 {
        top: 44%;
        left: 55%;
      }
      &_36 {
        top: 45.5%;
        left: 47%;
      }
      &_37 {
        top: 45%;
        left: 44.5%;
      }
      &_38 {
        top: 46%;
        left: 51.5%;
      }
      &_39 {
        top: 46%;
        left: 58.5%;
      }
      &_40 {
        top: 43%;
        left: 64.5%;
      }

      &_41 {
        top: 47%;
        left: 65.5%;
      }
      &_42 {
        top: 46.5%;
        left: 62.5%;
      }
      &_43 {
        top: 47%;
        left: 60.5%;
      }
      &_44 {
        top: 47.5%;
        left: 57%;
      }
      &_45 {
        top: 46%;
        left: 54%;
      }
      &_46 {
        top: 48%;
        left: 51%;
      }
      &_47 {
        top: 49%;
        left: 47.5%;
      }
      &_48 {
        top: 49.5%;
        left: 55.5%;
      }
      &_49 {
        top: 50%;
        left: 53.5%;
      }
      &_50 {
        top: 50%;
        left: 51.5%;
      }

      &_51 {
        top: 50.5%;
        left: 49%;
      }
      &_52 {
        top: 50.6%;
        left: 47%;
      }
      &_53 {
        top: 48.5%;
        left: 44.5%;
      }
      &_54 {
        top: 47%;
        left: 42.5%;
      }
      &_55 {
        top: 52%;
        left: 42%;
      }
      &_56 {
        top: 50.5%;
        left: 41.5%;
      }
      &_57 {
        top: 47%;
        left: 68.5%;
      }
      &_58 {
        top: 55%;
        left: 51%;
      }
      &_59 {
        top: 55%;
        left: 54%;
      }
      &_60 {
        top: 54.3%;
        left: 57%;
      }

      &_61 {
        top: 53.3%;
        left: 60%;
      }
      &_62 {
        top: 52%;
        left: 63%;
      }
      &_63 {
        top: 49.5%;
        left: 60%;
      }
      &_64 {
        top: 50.3%;
        left: 65%;
      }
      &_65 {
        top: 50.5%;
        left: 70.5%;
      }
      &_66 {
        top: 53%;
        left: 67%;
      }
      &_67 {
        top: 54%;
        left: 65%;
      }
      &_68 {
        top: 56.3%;
        left: 57.5%;
      }
      &_69 {
        top: 57.3%;
        left: 54.5%;
      }
      &_70 {
        top: 58%;
        left: 50.7%;
      }

      &_71 {
        top: 56%;
        left: 48.7%;
      }
      &_72 {
        top: 53.5%;
        left: 46.7%;
      }
      &_73 {
        top: 56.4%;
        left: 43.5%;
      }
      &_74 {
        top: 54%;
        left: 40.7%;
      }
      &_75 {
        top: 53%;
        left: 38.7%;
      }
      &_76 {
        top: 56%;
        left: 60.5%;
      }
      &_77 {
        top: 56%;
        left: 63.5%;
      }
      &_78 {
        top: 59.3%;
        left: 59.7%;
      }
      &_79 {
        top: 58%;
        left: 62.7%;
      }
      &_80 {
        top: 58.8%;
        left: 65.3%;
      }

      &_81 {
        top: 56.8%;
        left: 66.3%;
      }
      &_82 {
        top: 58.2%;
        left: 68%;
      }
      &_83 {
        top: 59.8%;
        left: 67.3%;
      }
      &_84 {
        top: 60.2%;
        left: 70.1%;
      }
      &_85 {
        top: 58.5%;
        left: 72.3%;
      }
      &_86 {
        top: 61.8%;
        left: 61.5%;
      }
      &_87 {
        top: 62.8%;
        left: 59.3%;
      }
      &_88 {
        top: 60%;
        left: 53.3%;
      }
      &_89 {
        top: 63%;
        left: 51.5%;
      }
      &_90 {
        top: 58.2%;
        left: 47.3%;
      }

      &_91 {
        top: 58%;
        left: 45.3%;
      }
      &_92 {
        top: 58.2%;
        left: 40.3%;
      }
      &_93 {
        top: 57.2%;
        left: 38.3%;
      }
      &_94 {
        top: 61%;
        left: 45.8%;
      }
      &_95 {
        top: 62.5%;
        left: 44.3%;
      }
      &_96 {
        top: 64.2%;
        left: 45.8%;
      }
      &_97 {
        top: 61.8%;
        left: 49.7%;
      }
      &_98 {
        top: 61.8%;
        left: 53%;
      }
      &_99 {
        top: 63.2%;
        left: 54.8%;
      }
      &_100 {
        top: 63.8%;
        left: 48.2%;
      }

      &_101 {
        top: 67.3%;
        left: 49.2%;
      }
      &_102 {
        top: 65.8%;
        left: 52.2%;
      }
      &_103 {
        top: 65.5%;
        left: 55.2%;
      }
      &_104 {
        top: 65.3%;
        left: 60%;
      }
      &_105 {
        top: 64.3%;
        left: 62.3%;
      }
      &_106 {
        top: 63.5%;
        left: 66%;
      }
      &_107 {
        top: 61.8%;
        left: 68.2%;
      }
      &_108 {
        top: 62.4%;
        left: 71.2%;
      }
      &_109 {
        top: 63.5%;
        left: 73.2%;
      }
      &_110 {
        top: 67%;
        left: 54.2%;
      }

      &_111 {
        top: 67%;
        left: 58.2%;
      }
      &_112 {
        top: 66.5%;
        left: 61.5%;
      }
      &_113 {
        top: 66%;
        left: 65.2%;
      }
      &_114 {
        top: 65%;
        left: 68.2%;
      }
      &_115 {
        top: 64%;
        left: 70.5%;
      }
      &_116 {
        top: 69%;
        left: 70.2%;
      }
      &_117 {
        top: 70.5%;
        left: 68%;
      }
      &_118 {
        top: 70%;
        left: 72.9%;
      }
      &_119 {
        top: 68%;
        left: 67.2%;
      }
      &_120 {
        top: 69.5%;
        left: 54.5%;
      }

      &_121 {
        top: 69.5%;
        left: 49.2%;
      }
      &_122 {
        top: 71.5%;
        left: 49.5%;
      }
      &_123 {
        top: 70.5%;
        left: 47.2%;
      }
      &_124 {
        top: 68.5%;
        left: 52%;
      }
      &_125 {
        top: 71.5%;
        left: 53.5%;
      }
      &_126 {
        top: 69.5%;
        left: 59%;
      }
      &_127 {
        top: 68.5%;
        left: 62.5%;
      }
      &_128 {
        top: 71.5%;
        left: 58.5%;
      }
      &_129 {
        top: 70.5%;
        left: 62%;
      }
    }
  }
  .fade {
    &-enter {
      opacity: 0;
    }
    &-enter-active {
      transition: opacity .5s .5s;
    }
    &-leave-active {
      opacity: 0;
      transition: opacity .5s;
    }
  }

  @include mobile_or_P {
    width: 46rem;
  }
}
</style>